export const SET_ORACLE_PERSONA = 'SET_ORACLE_PERSONA'
export const SET_ORACLE_ACCESS_PROCESSING = 'SET_ORACLE_ACCESS_PROCESSING'
export const SET_ORACLE_ACCESS = 'SET_ORACLE_ACCESS'
export const SET_ORACLE_ACCESS_ERROR = 'SET_ORACLE_ACCESS_ERROR'

export function setOraclePersona (persona) {
  return {
    type: SET_ORACLE_PERSONA,
    payload: { persona },
  }
}

export function setOracleAccessProcessing (processing) {
  return {
    type: SET_ORACLE_ACCESS_PROCESSING,
    payload: { processing },
  }
}

export function setOracleAccess (access, processing = false) {
  return {
    type: SET_ORACLE_ACCESS,
    payload: { access, processing },
  }
}

export function setOracleAccessError (error) {
  return {
    type: SET_ORACLE_ACCESS_ERROR,
    payload: { error },
  }
}
